export class cuentaBancaria {
  NAME: string;
  BANK_ID: number;
  BANK_ACCOUNT_ID: number;
  ACCOUNT_ID: number;
  CLABE: number;
  loacs?: string;
  HOLDER: string;
  ACCCOUNT_NUMBER: string;
  CARD_NUMBER: string;
}


// WEBPACK FOOTER //
// ./src/app/models/cuentaBancaria.ts